import Vue from "vue";
import Router from "vue-router";
import store from '@/store'
import ProgressComponents from "@/components/ProgressComponents.vue";
import {
    Authenticate,
    ReportIntroduction,
    ReportForm,
    ReportSummary,
    List,
    ReportStart,
    ReportGeneralInformation,
    ReportSingle,
    ReportAdminSummary
} from "@/views";
import ReportGenerated from "@/views/ReportGenerated.vue";

Vue.use(Router);

const meta = {
    requiresAuth: true
};

const routes = [
    {
        path: "/",
        name: "home",
        redirect: "/login"
    },
    {
        path: "/login",
        name: "login",
        component: Authenticate
    },
    {
        path: "/list",
        name: "list",
        component: List,
        meta
    },
    {
        path: "/adminsummary/:id",
        name: "adminSummary",
        component: ReportAdminSummary,
        meta
    },
    {
        path: "/report",
        component: ProgressComponents,
        children: [
            {
                path: "start",
                name: "start",
                component: ReportStart,
                meta
            },
            {
                path: "introduction",
                name: "introduction",
                component: ReportIntroduction,
                meta
            },
            {
                path: "general/:id",
                name: "general",
                component: ReportGeneralInformation,
                meta
            },
            {
                path: "form/:id",
                name: "form",
                component: ReportForm,
                meta
            },
            {
                path: "summary/:id",
                name: "summary",
                component: ReportSummary,
                meta
            },
            {
                path: "generated",
                name: "generated",
                component: ReportGenerated,
                meta
            },
            {
                path: "single/:id",
                name: "single",
                component: ReportSingle,
                meta
            }
        ]
    },
    { path: '*', redirect: '/' }
];

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,

    routes
});

router.beforeEach(async (to, from, next) => {
    const { isLogged } = store.state['user'];

    if (isLogged) {
        // already signed in, we can navigate anywhere
        next();
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        router.push('/login');
    } else {
        //No auth required. We can navigate
        next();
    }
});

export default router;
